import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSneaker$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSneaker extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '9aa3452cfe3d6facd8246ed2bd9ecfeec6751158', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'bd2f8bed4ef0992083286129da6eeaa80a54a36c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '73254190e9fc634f06db4e0a4d732672c9d9ae8e', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m18.114 9.142-7.81-2.545a2 2 0 0 0-1.021-.054l-5.885 1.25A.506.506 0 0 0 3 8.29v4.664A3.023 3.023 0 0 0 6 16h11a3.023 3.023 0 0 0 3-3.046v-.984a3.05 3.05 0 0 0-1.886-2.828m.386 3.812a1.51 1.51 0 0 1-1.5 1.523H6a1.51 1.51 0 0 1-1.5-1.523v-3.84l5.09-1.08a.5.5 0 0 1 .255.013l1.784.581-.583 1.776a.51.51 0 0 0 .316.642l.475.161a.5.5 0 0 0 .633-.321l.588-1.792 1.582.516-.594 1.81a.51.51 0 0 0 .316.642l.475.161a.5.5 0 0 0 .633-.321l.6-1.826 1.527.498c.552.244.907.792.903 1.396z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-sneaker", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-sneaker"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-sneaker":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSneaker$1);
            }
            break;
    } });
}

const CosmosIconSneaker = CosmosIconSneaker$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSneaker, defineCustomElement };
